import { connect } from "react-redux";
import { Actions as ADVENTCALENDARACTIONS } from "../../store/actions/adventCalendarActions";
import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

import LoginRegister from "./LoginRegister";
function SignInModal({ closeSignInModal, signInModal, loggedIn }) {

    // if (loggedIn) return null

	return (
		<Transition.Root
			show={signInModal}
			as={Fragment}
		>
			<Dialog
				as="div"
				className="fixed z-50"
				onClose={() => {
					closeSignInModal();
				}}
			>
				<div className="fixed inset-0 z-50 w-screen overflow-y-auto">
					<div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0 overflow-hidden">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
							<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
						</Transition.Child>

						<span
							className="hidden sm:inline-block sm:align-middle sm:h-screen"
							aria-hidden="true"
						>
							&#8203;
						</span>
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
                            <div>
							    <LoginRegister />
                            </div>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
}

const mapStateToProps = (state) => {
	return {
		signInModal: state.adventCalendar.signInModal || false,
		loggedIn: !!state.my.profile?.email,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeSignInModal: () => dispatch(ADVENTCALENDARACTIONS.toggleSignInModal(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInModal);

